import Footer from '../../components/Footer/Footer';
import SideBar from '../../components/SideBar/SideBar';
import NavBar1 from '../../components/Navbar1/NavBar1';
import CategoryProducts from '../../components/CategoryProducts/CategoryProducts';


const category = () => {

    return (
        <>
            <NavBar1 />
            <SideBar subcategory={true}> 
                <Footer>
                    <CategoryProducts />
                
                </Footer>
            </SideBar>

        </>
    ) 
}

export default category; 